import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { MotoresTransmissaoService } from 'src/app/services/motores-transmissao/motores-transmissao.service';

@Component({
  selector: 'app-view-motores-transmissao',
  templateUrl: './view-motores-transmissao.component.html',
  styleUrl: './view-motores-transmissao.component.css'
})
export class ViewMotoresTransmissaoComponent implements OnInit {
  constructor(private readonly router: Router,
    private readonly motoresTransmissaoService: MotoresTransmissaoService) { }

  config: boolean = false;
  dateInterval: any
  updateInterval: any
  motoresTransmissaoDocks: DocksModel[] = []
  dockId!: number
  selectedDock: number | any;
  faFilter = faFilter

  ngOnInit() {
    this.updateData();

    this.dateInterval = setInterval(() => {
      this.updateData();
    }, 5000);
  }

  updateData(): void {
    this.motoresTransmissaoService.getEngineAndTransmissionDocksDataView().pipe
      (take(1),
        catchError(() => {
          return of([])
        })
      ).subscribe(
        (response) => {
          this.motoresTransmissaoDocks = response.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
  }


  changeDockPage() {
    if (this.selectedDock !== null) {
      this.config = false;
      this.router.navigate([`/view/motores-transmissao/dock/${this.selectedDock}`]);
    }
  }
}
